import React from 'react'
import { useTranslation } from 'react-i18next';
import { getSchoolYear } from '../../../util/validation';
import { Dropdown } from '@/components/Global';
import { useDispatch, useSelector } from 'react-redux';
import teacherActions from '../../../state/teacher/actions'
import { getWeeksInRange, isDateInRange } from '../../../util/datetime';
import moment from 'moment';

export default function UsageWindowSelect({isDisabled}) {
  const {t, i18n} = useTranslation("reports_sidebar");
  const dispatch = useDispatch();
  const { value, startDate, endDate } = useSelector(state => state.reports.teacher.usageWindow);
  const setTeacherReduxState = update => dispatch(teacherActions.setState(update));
  const handleChange = (selection) => {
    const newUsageWindow = {
      value: selection.value,
      startDate: selection.startDate,
      endDate: selection.endDate
    };
    setTeacherReduxState({usageWindow: newUsageWindow});
  };
  
  const translateOptionLabel = ({value, label, isThisWeek, isLastWeek, startDate, endDate}) => {
    if (value === "school_year") {
      label = t("school_year");
    } else {
      const {labelStart, labelEnd} = getDateLabelsForUsageWindow({startDate, endDate}, i18n.language);
      label = t((isThisWeek ? "this_week" : isLastWeek ? "last_week" : "usage_week"), {labelStart, labelEnd});
    }
    return {
      value,
      label,
      startDate,
      endDate
    };
  }

  // Compute the current label dynamically from the current value
  const options = getUsageWindowOptions().map(translateOptionLabel);
  const currentOption = options.find(option => option.value === value);
  const currentValue = currentOption ? { value: currentOption.value, label: currentOption.label } : { value, label: value };

  return (
    <Dropdown
      options={options}
      value={currentValue}
      onChange={handleChange}
      isDisabled={isDisabled}
    />
  )
}

export function getUsageWindowOptions() {
  const {
    startDate: schoolYearStartDate,
    endDate: schoolYearEndDate
  } = getSchoolYear();
  return getWeeksInRange(schoolYearStartDate, schoolYearEndDate).reverse().reduce((acc, week) => {
    const {startDate, endDate} = week;
    if (startDate >= new Date()) return acc;
    const thisWeek = new Date();
    const lastWeek = moment().subtract(7, 'days').toDate();
    acc.push({
      value: `week_${moment(startDate).format('YYYY-MM-DD')}`,
      startDate: moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      isThisWeek: isDateInRange(thisWeek, startDate, endDate),
      isLastWeek: isDateInRange(lastWeek, startDate, endDate)
    });
    return acc;
  }, [{
    value: "school_year",
    startDate: moment(schoolYearStartDate).format('YYYY-MM-DD'),
    endDate: moment(schoolYearEndDate).format('YYYY-MM-DD'),
  }]);
}

export function getDateLabelsForUsageWindow({startDate, endDate}, language) {
  moment.locale(language);
  const dateFormat = language === 'en' ? "MMM D" : "D [de] MMM";
  return {
    labelStart: moment(startDate).format(dateFormat),
    labelEnd: moment(endDate).format(dateFormat)
  }
}